module.exports = __webpack_public_path__ + "static/media/lockIcon.fc6adce9.svg";